var exports = {
  "Qs": "x24da60e8--b9f851--content",
  "Qq": "x24da60e8--b9f851--text",
  "ok": "x24da60e8--b9f851--ok",
  "iq": "x24da60e8--b9f851--image-container",
};

module.exports = exports;
